import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {PointOfInterestService} from '../point-of-interest.service';
import {RenderStrategy} from '../../enums/render-strategy';
import {CategoryService} from '../category.service';
import {StoryService} from '../story.service';

export const pointOfInterestListResolver: ResolveFn<Promise<[void, void, void]>> = () => {
  return Promise.all([
    inject(CategoryService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(StoryService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(PointOfInterestService).resolveIndex(RenderStrategy.PREFER_SERVER),
  ]);
};
